module.exports = __webpack_public_path__ + "img/auditing.207db846.png";